module.exports = __webpack_public_path__ + "static/hyperv_11.6898870f.jpg";